<ion-content class="bg-color ion-content product">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <mat-card>
        <mat-card-title class="mc-title">
          <!-- <span class="table-header">System Config</span> -->
        </mat-card-title>
        <mat-card-content class="mc-content">
          <div class="table-container">
            <table mat-table matTableResponsive [dataSource]="configDataSource">

              <ng-container matColumnDef="config_name">
                <th mat-header-cell *matHeaderCellDef> Config Name </th>
                <td mat-cell *matCellDef="let element">{{element.config_description}} </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  <mat-slide-toggle color="danger" #toggle [(ngModel)]="element.config_value"
                    (ngModelChange)="configToggle($event, element.id)">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="configDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: configDisplayedColumns;"></tr>
            </table>

            <table *ngIf="!loading">
              <tr *ngIf="!configDataSource.length">
                <td style="text-align: center;" [attr.colspan]="configDisplayedColumns.length">
                  No Records Found
                </td>
              </tr>
            </table>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>